import { PageHeader } from '../../components/ui/PageHeader';
import { Card } from '../../components/ui/Card';

export function ProveedoresIndex() {
  return (
    <div>
      <PageHeader
        title="Proveedores"
        subtitle="Catálogo de proveedores chinos y otros — sección pendiente de desarrollar."
      />
      <Card>
        <p className="text-sm text-slate-600">
          Reorganización pendiente: aquí vivirán el listado de proveedores,
          su catálogo de productos (productos_proveedor) y el workflow de
          relación con ellos. De momento puedes seguir usando las páginas
          existentes vía URL directa (/proveedores-legacy, /catalogo-legacy).
        </p>
      </Card>
    </div>
  );
}
